import CheckoutPaymentCategory from 'domains/customer-checkout/molecules/payment-category'
import PropTypes from 'prop-types'

const propTypes = {
  paymentOptions          : PropTypes.array,
  selectedPaymentMethodId : PropTypes.number,
  handleSelectPayment     : PropTypes.func
}

/**
 * Displays the different Payment Options with a button to switch between the options
 *
 *  ### Payment Options
 *  - `suggestions`: recommended payment methods by Tinkerlust
 *  - `categories`: shows all the different payment methods sorted according to their type (Virtual Account, Bank Transfer, etc)
 *
 * @param {Object} paymentOptions - data holding different payment_methods in the format of payment_options
 * @param {Number} selectedPaymentMethodId - id of the backend model PaymentMethod
 * @param {Function} handleSelectPayment - receives a paymentMethod object to be saved in parent state
 */
const CustomerCheckoutPaymentOptions = ({
  paymentOptions,
  selectedPaymentMethodId,
  handleSelectPayment
}) => {

  const PaymentCategories = () => (
    paymentOptions.map((category, index) => (
      <CheckoutPaymentCategory
        key={ `checkout-payment-category-${index}` }
        label={ category.label }
        paymentMethods={ category.payment_methods }
        selectedPaymentMethodId={ selectedPaymentMethodId }
        handleSelectPayment={ handleSelectPayment }
      />
    ))
  )

  return (
    <>
      <PaymentCategories />
    </>
  )
}

CustomerCheckoutPaymentOptions.propTypes = {
  paymentOptions: PropTypes.shape({
    suggestions : PropTypes.array.isRequired,
    categories  : PropTypes.array.isRequired
  }),
  selectedPaymentMethodId : PropTypes.number.isRequired,
  handleSelectPayment     : PropTypes.func.isRequired
}

CustomerCheckoutPaymentOptions.defaultProps = {
  paymentOptions: {
    suggestions : [],
    categories  : []
  },
  selectedPaymentMethodId : -1,
  handleSelectPayment     : () => { alert('Selected Payment!')}
}

CustomerCheckoutPaymentOptions.propTypes = propTypes

export default CustomerCheckoutPaymentOptions